import { render, staticRenderFns } from "./PrecisionMarketingIndex.vue?vue&type=template&id=d1457fd2&scoped=true"
import script from "./PrecisionMarketingIndex.vue?vue&type=script&lang=js"
export * from "./PrecisionMarketingIndex.vue?vue&type=script&lang=js"
import style0 from "./PrecisionMarketingIndex.vue?vue&type=style&index=0&id=d1457fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1457fd2",
  null
  
)

export default component.exports